<template>
    <CustomHeader :text="$t('gameLog.gameRegistration')" :is-popup-close-back-icon="true" @closePopup="navToBackPage" />
    <div class="container">
        <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="onClickTab">
            <van-tab v-for="(item, index) in dataSet.tabList" :key="index" :title="`${item.timeName} ${$t(item.name)}`"
                :name="index">
                <div class="content">
                    <div class="top_card">
                        <div class="card_text">{{ $t('gameLog.latestData') }} {{ item.timeName + ' ' + $t(item.name) }}</div>
                        <div class="card_text">{{ $t('common.bets') }} {{ dataSet.total }} {{ $t('common.times') }}:
                            <span>
                                {{ formatCurrency(dataSet.betTotal) }}
                            </span>
                        </div>
                        <div class="card_text">{{ $t('gameLog.winOrLoss') }}：
                            <span>
                                {{ formatCurrency(dataSet.winLossAmount) }}
                            </span>
                        </div>
                    </div>
                    <div v-if="dataSet.betList.length > 0" style="padding: 15px;">
                        <div v-for="(item, index) in dataSet.betList" :key="index">
                            <LogCard :bet-amount="item.betAmount" :returnAmount="item.winAmount" :profit="item.income"
                                :time="item.createTime" :sessionId="item.orderNo" :gameName="item.gameName" />
                        </div>
                        <van-row v-if="dataSet.total > dataSet.pageSize * dataSet.pageNum">
                            <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                                    @click="getNextPageMsgList"></van-col>
                        </van-row>
                        <div v-else class="no_more">{{ $t('message.noMore') }}</div>
                    </div>
                    <div v-else>
                        <NoDataCustom />
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import LogCard from './components/logCard.vue';
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import { GameLogData } from '@/view/gameLog/supportScript';
import { useRouter } from 'vue-router';
import NoDataCustom from '../components/common/noDataCustom.vue';

const router = useRouter()
const props = defineProps<{
    dataSet: GameLogData
}>()

const active = ref(props.dataSet.active);

const emits = defineEmits(['onClickTab', 'getNextPageMsgList'])

const onClickTab = (active: any) => {
    emits('onClickTab', active)
}
const getNextPageMsgList = () => {
    emits('getNextPageMsgList')
}
const navToBackPage = () => {
    router.go(-1)
}
</script>
<style scoped>
.container {
    padding: 70px 0;
    background: #090f1e;

}

.container>>>.van-tabs__nav {
    background: transparent;
    width: 90%;
    margin: 0 2.5%;
}

.container>>>.van-tab {
    border-radius: 10px;
    font-size: 15px;
    margin: 3px;
    height: 35px;
    padding: 0 15px;
    color: #fff;
}

.container>>>.van-tab.van-tab--active {
    background: linear-gradient(0deg, #0167ca 0%, #38a8fa 100%);
    color: #fff;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.content {
    color: #fff;
    flex: 1;
    overflow-y: auto;
    height: calc(100vh - 210px);
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.top_card {
    background: #1a223a;
    border-radius: 5px;
    padding: 15px;
}

.card_text {
    color: #8792af;
    font-size: 14px;
    padding: 2.5px 0;
}

.card_text span {
    font-size: 15px;
    color: #FBA531;
}

.sub_text {
    color: rgba(255, 255, 255, 0.45);
    text-align: center;
    padding: 15px 70px;
    font-size: 12px;
}

.no_more {
    color: #96addc98;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}

@media (max-width: 450px) {
    .card_text {
        font-size: 12px;
    }

    .card_text span {
        font-size: 12px;
    }
}
</style>